(function() {
  var lastVariantId = null;

  function getVariantIdFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return Number(params.get('variant'));
  }

  function dispatchVariantChange(variantId) {
    if (variantId && variantId !== lastVariantId) {
      lastVariantId = variantId;
      document.dispatchEvent(new CustomEvent("pbx:variant:change", {
        detail: { variantId: variantId }
      }));
    }
  }

  // Dispatch on initial load if variant is in URL
  var initialVariant = getVariantIdFromUrl();
  if (initialVariant) {
    dispatchVariantChange(initialVariant);
  }

  // Watch for variant input changes in add-to-cart forms
  document.addEventListener('change', function(e) {
    var target = e.target;
    if (target.name === 'id' && target.closest('form[action*="/cart/add"]')) {
      dispatchVariantChange(target.value);
    }
  });

  // Watch for URL changes (variant selection updates URL)
  var pushState = history.pushState;
  history.pushState = function() {
    pushState.apply(history, arguments);
    var variantId = getVariantIdFromUrl();
    if (variantId) {
      dispatchVariantChange(variantId);
    }
  };

  var replaceState = history.replaceState;
  history.replaceState = function() {
    replaceState.apply(history, arguments);
    var variantId = getVariantIdFromUrl();
    if (variantId) {
      dispatchVariantChange(variantId);
    }
  };

  window.addEventListener('popstate', function() {
    var variantId = getVariantIdFromUrl();
    if (variantId) {
      dispatchVariantChange(variantId);
    }
  });
})();
